/**
 * Calls onForeground every time the tab becomes visible again; returns the function that removes the listener.
 * Used to read the config (maintenance flag) again when the user comes back to the portal.
 */
export const subscribeToPageVisible = (onForeground: () => void): (() => void) => {
  const listener = () => {
    if (document.visibilityState === 'visible') {
      onForeground();
    }
  };
  document.addEventListener('visibilitychange', listener);
  return () => document.removeEventListener('visibilitychange', listener);
};
